import { render, staticRenderFns } from "./SystemUserLayout.vue?vue&type=template&id=083a9b26&scoped=true"
import script from "./SystemUserLayout.vue?vue&type=script&lang=js"
export * from "./SystemUserLayout.vue?vue&type=script&lang=js"
import style0 from "./SystemUserLayout.vue?vue&type=style&index=0&id=083a9b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083a9b26",
  null
  
)

export default component.exports